enum AccountDetailsCollateralClassification {
  SECURED = 'SECURED',
  UNSECURED = 'UNSECURED',
}

export default AccountDetailsCollateralClassification;
